/**
 * @typedef {{isGated?: boolean}} Props
 * @typedef {import("./Types/BlogsEmbedState").default} State
 * @typedef {import('../../../shared/BlogService/BlogPostExcerpt').default} Blogs
 */

import { translate } from '../../Internationalization';
import BlogCard from './BlogCard';
import Loading from '../../../shared/Loading';
import NoContent from '../../../shared/NoContent';
import React from 'react';
import useGetAgentsPersonalData from '../../../Hooks/Agent/Getters/useGetAgentsPersonalData/useGetAgentsPersonalData';
import useGetBlogs from '../../../Hooks/Shared/Getters/useGetBlogs/useGetBlogs';

/**
 * @param {Props} props
 * @returns {JSX.Element}
 */
export default function BlogsEmbed(props) {
	const agent = useGetAgentsPersonalData();
	const blogs = useGetBlogs(props.isGated);

	if (blogs.isGettingData) {
		return <Loading />;
	}

	if (blogs.isError || !blogs.data?.length) {
		return (
			<NoContent
				message={translate('homeowner.dashboard.marketplace.error')}
			/>
		);
	}

	return (
		<section className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 mb-8">
			{blogs.data.map((postExcerpt) => (
				<BlogCard
					agentSlug={agent?.data?.slug}
					content={postExcerpt.content}
					date={postExcerpt.date}
					imageUrl={postExcerpt.imageUrl}
					isGated={props.isGated}
					key={postExcerpt.slug}
					slug={postExcerpt.slug}
					title={postExcerpt.title}
				/>
			))}
		</section>
	);
}
